const routes = {
  workingSheet: "/sheets/working-sheet",
  invoiceWorkingSheet: "/sheets/invoice-working-sheet",
}

export default routes
